<template>
  <BaseChecklist
    v-bind="$attrs"
    v-model="modelValue"
    :loading="isFetching"
    :options="options"
    label="Coverholders"
    :search-keys="['text']"
    searchable
  />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import {
  useCurrentUser,
  useUserCompany,
  useRLSGroup,
  useUserCompanyRLS
} from '@composables'
import { BaseChecklist } from '@components/base'

export default defineComponent({
  name: 'BDXWizardCoverholders',
  components: {
    BaseChecklist
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { isSuperUser } = useCurrentUser()
    const { roleValue: companyRoleValue } = useUserCompany()

    const { isFetching, rlsGroupItems } = useRLSGroup('Coverholder')
    const { coverholderIds } = useUserCompanyRLS()

    const options = computed(() =>
      rlsGroupItems.value
        .filter((rlsGroupItem) => {
          if (isSuperUser.value) return true

          return coverholderIds.value.includes(rlsGroupItem.id)
        })
        .map((rlsGroupItem) => ({
          value: rlsGroupItem.id,
          text: rlsGroupItem.coverholder
        }))
    )

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      isFetching,

      options,
      modelValue
    }
  }
})
</script>
